<form [formGroup]="formEducation" (submit)="addEducation()" style="margin-top: 20px">
  <fieldset>
    <div class="row">
      <mat-list role="list" *ngIf="educations.length">
        <h3 matSubheader>Cursos</h3>
        <ng-container *ngFor="let education of educations; let i = index">
          <mat-list-item>
            <h3 matLine>
              {{ education.courseName }} - {{ education.institutionName }}
            </h3>
            <p matLine>
              <span>de {{ education.dateStart | date : "dd/MM/yyyy" }} até
                {{ education.dateEnd | date : "dd/MM/yyyy" }}</span>
            </p>
            <button type="button" mat-icon-button color="warn" (click)="removeItem(i)">
              <mat-icon>remove</mat-icon>
            </button>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </div>

    <ng-container *ngIf="showForm">
      <legend>Escolaridade</legend>

      <div class="row" style="margin-top: 20px">
        <mat-form-field appearance="outline">
          <mat-label>Nível educacional</mat-label>
          <mat-select placeholder="Selecione um nivel educacional" formControlName="educationLevel">
            <mat-option value="ens-sup-nivel4">Ensino Superior (Doutorado)</mat-option>
            <mat-option value="ens-sup-nivel3">Ensino Superior (Mestrado)</mat-option>
            <mat-option value="ens-sup-nivel2">Ensino Superior (Pós graduação)</mat-option>
            <mat-option value="ens-sup-nivel">Ensino Superior (Graduação)</mat-option>
            <mat-option value="ens-med-nivel">Ensino Médio</mat-option>
            <mat-option value="ens-fun-nivel">Ensino Fundamental</mat-option>
            <mat-option value="curso-tecnico">Outros Técnico</mat-option>
            <mat-option value="mba">MBA</mat-option>
            <mat-option value="curso-extra">Outros Cursos</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <mat-form-field appearance="outline">
          <mat-label>Nome instituição</mat-label>
          <input type="text" matInput placeholder="Nome da instituição" formControlName="institutionName" />
        </mat-form-field> -->
      </div>

      <!-- <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Nome do curso</mat-label>
          <input type="text" matInput placeholder="Nome do curso" formControlName="courseName" />
        </mat-form-field>
      </div>

      <div class="row" style="margin-bottom: 20px">
        <mat-slide-toggle
          color="primary"
          formControlName="currentCourse"
          (change)="toggleDateValidation(formEducation)"
          >Estou atualmente nesse curso</mat-slide-toggle
        >
      </div> -->

      <!-- <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Data de início</mat-label>
          <input type="text" matInput placeholder="MM/YYYY" formControlName="dateStart" mask="00/0000"
            inputmode="numeric" />
          <mat-error *ngIf="formEducation.get('dateStart').errors?.invalidDate === true">Informe uma data
            válida</mat-error>
          <mat-error *ngIf="formEducation.get('dateStart').errors?.beforeDate === true">Data não pode ser maior que a
            data de término</mat-error>
        </mat-form-field>

        <ng-container *ngIf="formEducation.get('currentCourse').value === false">
          <mat-form-field appearance="outline">
            <mat-label>Data de término</mat-label>
            <input type="text" matInput placeholder="MM/YYYY" formControlName="dateEnd" mask="00/0000"
              inputmode="numeric" />
            <mat-error *ngIf="formEducation.get('dateEnd').errors?.departure === true">Informe a data de término desse
              curso</mat-error>
            <mat-error *ngIf="formEducation.get('dateEnd').errors?.invalidDate === true">Informe uma data
              válida</mat-error>
            <mat-error *ngIf="formEducation.get('dateEnd').errors?.maxDate === true">Data não pode ser maior que a
              atual</mat-error>
          </mat-form-field>
        </ng-container>
      </div> -->
    </ng-container>
  </fieldset>
</form>

<form [formGroup]="formEducation2" style="margin-top: 20px">
  <fieldset>
    <div class="row">
      <mat-list role="list" *ngIf="educations.length">
        <h3 matSubheader>Cursos</h3>
        <ng-container *ngFor="let education of educations; let i = index">
          <mat-list-item>
            <h3 matLine>
              {{ education.courseName }} - {{ education.institutionName }}
            </h3>
            <p matLine>
              <span>de {{ education.dateStart | date : "dd/MM/yyyy" }} até
                {{ education.dateEnd | date : "dd/MM/yyyy" }}</span>
            </p>
            <button type="button" mat-icon-button color="warn" (click)="removeItem(i)">
              <mat-icon>remove</mat-icon>
            </button>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </div>

    <ng-container *ngIf="showForm">
      <legend>Cursos</legend>

      <div class="row" style="margin-top: 20px">
        <mat-form-field appearance="outline">
          <mat-label>Nível educacional</mat-label>
          <mat-select placeholder="Selecione um nivel educacional" formControlName="educationLevel">
            <mat-option value="ens-sup-nivel4">Ensino Superior (Doutorado)</mat-option>
            <mat-option value="ens-sup-nivel3">Ensino Superior (Mestrado)</mat-option>
            <mat-option value="ens-sup-nivel2">Ensino Superior (Pós graduação)</mat-option>
            <mat-option value="ens-sup-nivel">Ensino Superior (Graduação)</mat-option>
            <mat-option value="ens-med-nivel">Ensino Médio</mat-option>
            <mat-option value="ens-fun-nivel">Ensino Fundamental</mat-option>
            <mat-option value="curso-tecnico">Outros Técnico</mat-option>
            <mat-option value="mba">MBA</mat-option>
            <mat-option value="curso-extra">Outros Cursos</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Nome instituição</mat-label>
          <input type="text" matInput placeholder="Nome da instituição" formControlName="institutionName" />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Nome do curso</mat-label>
          <input type="text" matInput placeholder="Nome do curso" formControlName="courseName" />
        </mat-form-field>
      </div>

      <div class="row" style="margin-bottom: 20px">
        <mat-slide-toggle color="primary" formControlName="currentCourse"
          (change)="toggleDateValidation(formEducation2)">Estou atualmente nesse curso</mat-slide-toggle>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Data de início</mat-label>
          <input type="text" matInput placeholder="MM/YYYY" formControlName="dateStart" mask="00/0000"
            inputmode="numeric" />
          <mat-error *ngIf="formEducation2.get('dateStart').errors?.invalidDate === true">Informe uma data
            válida</mat-error>
          <mat-error *ngIf="formEducation2.get('dateStart').errors?.beforeDate === true">Data não pode ser maior que a
            data de término</mat-error>
        </mat-form-field>

        <ng-container *ngIf="formEducation2.get('currentCourse').value === false">
          <mat-form-field appearance="outline">
            <mat-label>Data de término</mat-label>
            <input type="text" matInput placeholder="MM/YYYY" formControlName="dateEnd" mask="00/0000"
              inputmode="numeric" />
            <mat-error *ngIf="formEducation2.get('dateEnd').errors?.departure === true">Informe a data de término desse
              curso</mat-error>
            <mat-error *ngIf="formEducation2.get('dateEnd').errors?.invalidDate === true">Informe uma data
              válida</mat-error>
            <mat-error *ngIf="formEducation2.get('dateEnd').errors?.maxDate === true">Data não pode ser maior que a
              atual</mat-error>
          </mat-form-field>
        </ng-container>
      </div>
    </ng-container>

    <!-- <div class="actions" style="margin-bottom: 20px;">
            <button mat-stroked-button type="button" color="primary" *ngIf="!showForm" (click)="showForm = true">Adicionar curso</button>
            <button mat-stroked-button type="submit" color="primary" *ngIf="showForm">Salvar curso</button>
            <button mat-stroked-button type="button" color="warn" *ngIf="showForm" (click)="resetForm()">Cancelar</button>
        </div> -->
  </fieldset>
</form>

<div class="actions right">
  <button class="custom-primary" mat-raised-button type="submit" (click)="
      formEducation.valid && formEducation2.valid && onSubmit()
    " [disabled]="!formEducation.valid || (!formEducation2.valid && showForm)" matStepperNext>
    Continuar
  </button>
</div>

<iframe *ngIf="mauticFormSrc" [src]="mauticFormSrc" hidden frameborder="0"></iframe>